import "esbuild-css-modules-plugin-ns-css:src/ui/ViewerUI.module.css";

export default {
  "contents": "ViewerUI-module__contents_ne7v1W__0230",
  "emptyState": "ViewerUI-module__empty-state_ne7v1W__0230",
  "githubLink": "ViewerUI-module__github-link_ne7v1W__0230",
  "githubLogo": "ViewerUI-module__github-logo_ne7v1W__0230",
  "header": "ViewerUI-module__header_ne7v1W__0230",
  "logo": "ViewerUI-module__logo_ne7v1W__0230",
  "menuButton": "ViewerUI-module__menu-button_ne7v1W__0230",
  "title": "ViewerUI-module__title_ne7v1W__0230",
  "viewerUi": "ViewerUI-module__viewer-ui_ne7v1W__0230"
};
      